import { conditionalLog, conditionalError } from './conditionalLogger';

export const trackEvent = (type, payload = {}) => {
    // 1. Cooldown Mechanism for "View" events to prevent inflation from refreshes
    const COOLDOWN_MINUTES = 5;
    const isViewEvent = type.includes('VIEW') || type.includes('OPEN') || type.includes('IMPRESSION');
    
    if (isViewEvent) {
        try {
            // Create a unique key for this event + target
            const targetId = payload.slug || payload.commentId || payload.hangoutId || payload.userId || payload.campaignId || payload.surveyId || payload.entityId || payload.reportType || payload.reportId || payload.petId || payload.targetId || 'global';
            const cooldownKey = `track_cd_${type}_${targetId}`;
            const lastTracked = localStorage.getItem(cooldownKey);
            const now = Date.now();

            if (lastTracked && (now - parseInt(lastTracked)) < COOLDOWN_MINUTES * 60 * 1000) {
                conditionalLog(`[Analytics] Cooldown active for ${type} (${targetId}) - skipping server log.`);
                return;
            }

            // Update cooldown timestamp
            localStorage.setItem(cooldownKey, now.toString());
        } catch (e) {
            // LocalStorage might be full or blocked in some browsers, proceed anyway
        }
    }

    // 2. Enriched Payload & Attribution
    let attribution = {};
    let location = {};
    try {
        const storedAttr = sessionStorage.getItem('attribution_data');
        if (storedAttr) attribution = JSON.parse(storedAttr);

        const storedLoc = localStorage.getItem('user_location');
        if (storedLoc) location = JSON.parse(storedLoc);
    } catch (e) { }

    const appContext = localStorage.getItem('hs_app_context') || 'HANGOUT';

    const enrichedPayload = {
        ...attribution,
        ...location,
        ...payload,
        app_context: appContext,
        url: window.location.pathname,
        referrer: document.referrer || 'direct'
    };

    // 3. Fire and Forget Tracking & Update Activity Timer
    localStorage.setItem('hs_last_activity', Date.now().toString());

    fetch('/api/analytics/track', {
        method: 'POST',
        headers: { 
            'Content-Type': 'application/json',
            'x-session-id': sessionStorage.getItem('hs_session_id') || 'system'
        },
        body: JSON.stringify({
            type,
            payload: enrichedPayload,
            source: new URLSearchParams(window.location.search).get('ref')
        })
    }).catch(err => conditionalError("Tracking failed:", err));
};
